import * as React from 'react';
import { VideoContentDetail } from './Content/VideoContentDetail';
import { Image } from 'src/widgets/Image';
import { IContent } from './contentPreviewerModel';
import { getPreviewMedia } from './utils/getContentImage';
import styles from './ContentPreviewer.scss';

const { useState, useEffect } = React;

type IProps = {
  content: IContent;
};

export const ContentDetailItem = (props: IProps) => {
  const { content } = props;
  const [mimeType, setMimeType] = useState<string>('');
  const [previewUrl, setPreviewUrl] = useState<string>('');

  useEffect(() => {
    const determineMimeType = async (content: IContent) => {
      if (content.type === 'application') {
        const response = await fetch(content.src);

        if (!response.ok) {
          throw new Error('Failed to fetch media url');
        }

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);

        setMimeType(blob.type);
        setPreviewUrl(url);
      }
    };

    determineMimeType(content);
  }, [content]);

  const renderContent = () => {
    switch (content.type) {
      case 'video': {
        return (
          <VideoContentDetail
            key={content.src}
            src={content.src}
            showDuration
            controls
            className={styles.item}
          />
        );
      }

      case 'image': {
        return <Image src={getPreviewMedia(content)} className={styles.item} />;
      }

      case 'application': {
        if (mimeType === 'application/pdf') {
          return <embed src={previewUrl} className={styles.item} />;
        } else {
          return (
            <div className={styles.notSupportPreviewMsg}>
              Preview not supported. Please download the file to view.
            </div>
          );
        }
      }

      default: {
        return (
          <div className={styles.notSupportPreviewMsg}>
            Preview not supported. Please download the file to view.
          </div>
        );
      }
    }
  };

  if (content.type === 'application' && !mimeType) {return null;}

  return (
    <>{ renderContent() }</>
  );
};
